// import ForgotPassword from "../Components/Pages/MMPClient/Auth/ForgotPassword";
import PublicLayout from "../Components/Pages/Public";
import ThankyouPage from "../Components/Pages/Public/Form/Common/ThankyouPage";


export const PublicRoutes = [
  { path: `${process.env.PUBLIC_URL}/factfind`, element: <PublicLayout /> },
  // { path: `${process.env.PUBLIC_URL}/ForgotPassword`, element: <ForgotPassword /> },
  { path: `${process.env.PUBLIC_URL}/factfind-success`, element: <ThankyouPage /> },
  // { path: `${process.env.PUBLIC_URL}/`, element: <MMPLogin /> },
];